var _defs, _rect, _line, _line2, _line3, _line4, _line5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInverterter01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n\t\t.cls-1, .cls-2 {\n\t\tstroke: #ffffff;\n\t\tfill: none;\n\t\tstroke-miterlimit: 10;\n\t\t}\n\n\t\t.cls-1 {\n\t\tstroke-width: 0.25px;\n\t\t}\n\n\t\t.cls-2 {\n\t\tstroke-width: 0.1px;\n\t\t}\n\t"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Inverterter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.18,
    y: 6,
    width: 8.31,
    height: 4.78
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.18,
    y1: 10.78,
    x2: 12.49,
    y2: 6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.95,
    y1: 7.05,
    x2: 7.14,
    y2: 7.05
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 4.95,
    y1: 7.76,
    x2: 5.49,
    y2: 7.76
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 5.77,
    y1: 7.76,
    x2: 6.32,
    y2: 7.76
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.6,
    y1: 7.76,
    x2: 7.14,
    y2: 7.76
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10,9.62c.09-.29.24-.5.39-.5s.26.22.35.41.12.43.24.5a.63.63,0,0,0,.68-.26.69.69,0,0,0,.13-.35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInverterter01);
export default __webpack_public_path__ + "static/media/Inverterter-01.0bdfadf86d3273c4a02cc3a4f730de6d.svg";
export { ForwardRef as ReactComponent };